import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static readonly targets = ['input'];
  static readonly values = {
    maxChars: Number,
  };

  declare inputTarget: HTMLInputElement;
  declare readonly maxCharsValue: number;

  onChange() {
    this.inputTarget.value = this.inputTarget.value.replaceAll(/\D/g, '');
    if (this.inputTarget.value.length >= this.maxCharsValue) {
      this.submit();
    }
  }

  private submit() {
    // ENABLE THIS ONCE WE HAVE THE COMPLETE MAP, check submit URL on the form
    //this.inputTarget.readOnly = true;
    //(this.element as HTMLFormElement).requestSubmit();
  }
}
